import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { BackgroundSelectorComponent } from './background-selector/background-selector.component';
import { BackgroundCoreService } from './background-core.service';

@NgModule({
  declarations: [BackgroundSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [BackgroundCoreService],
  exports: [BackgroundSelectorComponent],
})
export class BackgroundCoreModule {}
